import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './radActionType';
import * as actions from './radActions';
import * as services from './radServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

// -------------------- Provider PROFILE BY ID --------------------
function* fetchRadProfileSaga(action) {
    try {
        const response = yield call(services.getRadProfileById, action.payload);

        if (response?.success) {
            yield put(actions.fetchRadProfileSuccess(response.values));
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(actions.fetchRadProfileFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage =
            'Failed to fetch Provider profile';

        yield put(actions.fetchRadProfileFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- RADIOLOGIST TASKS BY DATE --------------------
function* fetchRadiologistTasksByDateSaga(action) {
    try {
        const response = yield call(
            services.getRadiologistTasksByDate,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadiologistGetRadiologistTasksByDateSuccess(
                    response.values
                )
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadiologistGetRadiologistTasksByDateFailure(
                    errorMessage
                )
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to load Provider Tasks by Date';

        yield put(
            actions.fetchRadiologistGetRadiologistTasksByDateFailure(
                errorMessage
            )
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- ADD Provider SCHEDULE --------------------
function* addRadScheduleSaga(action) {
    try {
        const response = yield call(services.addRadSchedule, action.payload);

        if (response?.success) {
            yield put(actions.addRadScheduleSuccess(response.values));
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to add Provider Schedule';

            yield put(actions.addRadScheduleFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to add Provider Schedule';

        yield put(actions.addRadScheduleFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE Provider SCHEDULE --------------------
function* saveRadScheduleSaga(action) {
    try {
        const scheduleData = action?.payload?.scheduleData || action.payload;
        const refreshParams = action?.payload?.refreshParams;

        const response = yield call(
            services.saveRadSchedule,
            scheduleData
        );

        const isDuplicateScheduleError = (message) =>
            /already exists for this provider/i.test(String(message || ''));

        if (response?.success) {
            yield put(actions.saveRadScheduleSuccess(response));

            if (refreshParams?.type === 'byRange' && refreshParams?.payload) {
                yield put(
                    actions.fetchSchedulesByDateRangeRequest(
                        refreshParams.payload
                    )
                );
            } else if (refreshParams?.RadiologistID && refreshParams?.ShiftDate) {
                yield put(
                    actions.fetchRadiologistGetRadiologistTasksByDateRequest(
                        refreshParams
                    )
                );
            }

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Provider Schedule saved successfully.'
            });
        } else {
            const errorMessage = response?.errorMessage || 'Failed to save Provider Schedule';

            yield put(actions.saveRadScheduleFailure(errorMessage));

            if (!isDuplicateScheduleError(errorMessage)) {
                SweetAlert.error({ title: 'Error!', text: errorMessage });
            }
        }
    } catch (error) {
        const errorMessage = 'Failed to save Provider Schedule';
        yield put(actions.saveRadScheduleFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- UPDATE Provider SCHEDULE --------------------
function* updateRadScheduleSaga(action) {
    try {
        const scheduleData = action?.payload?.scheduleData || action.payload;
        const refreshParams = action?.payload?.refreshParams;

        const response = yield call(services.updateRadSchedule, scheduleData);

        const isDuplicateScheduleError = (message) =>
            /already exists for this provider/i.test(String(message || ''));

        if (response?.success) {
            yield put(actions.updateRadScheduleSuccess(response));

            if (refreshParams?.type === 'byRange' && refreshParams?.payload) {
                yield put(actions.fetchSchedulesByDateRangeRequest(refreshParams.payload));
            } else if (refreshParams?.RadiologistID && refreshParams?.ShiftDate) {
                yield put(actions.fetchRadiologistGetRadiologistTasksByDateRequest(refreshParams));
            }

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Provider Schedule updated successfully.'
            });
        } else {
            const errorMessage = response?.errorMessage || 'Failed to update Provider Schedule';

            yield put(actions.updateRadScheduleFailure(errorMessage));

            if (!isDuplicateScheduleError(errorMessage)) {
                SweetAlert.error({ title: 'Error!', text: errorMessage });
            }
        }
    } catch (error) {
        const errorMessage = 'Failed to update Provider Schedule';
        yield put(actions.updateRadScheduleFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- Provider PROFILE ASSOCIATED SITE METRICS --------------------
function* fetchRadProfileAssociatedSiteMatricsSaga(action) {
    try {
        const response = yield call(
            services.getRadProfileAssociatedSiteMatrics,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadProfileAssociatedSiteMatricsSuccess(
                    response.values
                )
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadProfileAssociatedSiteMatricsFailure(
                    errorMessage
                )
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Associated Facility Metrics';

        yield put(
            actions.fetchRadProfileAssociatedSiteMatricsFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- Provider SITE MATRIX DROPDOWN --------------------
function* fetchRadSiteMatrixDropdownSaga(action) {
    try {
        const response = yield call(
            services.getRadSiteMatrixDropdown,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadSiteMatrixDropdownSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadSiteMatrixDropdownFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Facility Encore Dropdown';

        yield put(actions.fetchRadSiteMatrixDropdownFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SITE METRICS CHILD TABLE --------------------
function* fetchSiteMetricsChildTableSaga(action) {
    try {
        const response = yield call(
            services.getSiteMetricsChildTable,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadProfileGetSiteMetricsChildTableSuccess(
                    response.values
                )
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadProfileGetSiteMetricsChildTableFailure(
                    errorMessage
                )
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Facility Metrics Child Table';

        yield put(
            actions.fetchRadProfileGetSiteMetricsChildTableFailure(
                errorMessage
            )
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- RADIOLOGIST YTD BY ID --------------------
function* fetchRadiologistYTDByIDSaga(action) {
    try {
        const response = yield call(
            services.getRadiologistYTDByID,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadiologistGetRadiologistYTDByIDSuccess(
                    response.values
                )
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadiologistGetRadiologistYTDByIDFailure(
                    errorMessage
                )
            );
            // SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Provider YTD';

        yield put(
            actions.fetchRadiologistGetRadiologistYTDByIDFailure(
                errorMessage
            )
        );
        // SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- Provider DROPDOWN TASKS --------------------
function* fetchRadDropdownTasksSaga(action) {
    try {
        const response = yield call(
            services.getRadDropdownTasks,
            action.payload
        );

        if (response?.success) {
            yield put(actions.fetchRadTasksDropdownSuccess(response.values));
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(actions.fetchRadTasksDropdownFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Provider Dropdown Tasks';
        yield put(actions.fetchRadTasksDropdownFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- DELETE SHIFT INPUT DETAILS --------------------
function* deleteShiftInputDetailsSaga(action) {
    try {
        const response = yield call(
            services.deleteShiftInputDetails,
            action.payload
        );

        if (response?.success) {
            yield put(actions.deleteShiftInputDetailsSuccess(response));
            SweetAlert.success({
                title: 'Success!',
                text:
                    response?.resultMessage ||
                    'Shift input details deleted successfully.'
            });
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to delete shift input details';

            yield put(actions.deleteShiftInputDetailsFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to delete shift input details';

        yield put(actions.deleteShiftInputDetailsFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH SCHEDULES BY DATE RANGE --------------------
function* fetchSchedulesByDateRangeSaga(action) {
    try {
        const response = yield call(
            services.getSchedulesByDateRange,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchSchedulesByDateRangeSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchSchedulesByDateRangeFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch schedules';

        yield put(actions.fetchSchedulesByDateRangeFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH SCHEDULE REQUEST --------------------
function* fetchScheduleRequestSaga(action) {
    try {
        const response = yield call(services.getScheduleRequest, action.payload);

        if (response?.success) {
            yield put(actions.fetchScheduleRequestSuccess(response.values));
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(actions.fetchScheduleRequestFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch schedule requests';
        yield put(actions.fetchScheduleRequestFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- DELETE SCHEDULE REQUEST --------------------
function* deleteScheduleRequestSaga(action) {
    try {
        const response = yield call(services.deleteScheduleRequest, action.payload);

        if (response?.success) {
            yield put(actions.deleteScheduleRequestSuccess(response));
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Schedule request deleted successfully.'
            });

            if (action?.payload?.RadiologistID) {
                yield put(actions.fetchScheduleRequestRequest({
                    RadiologistID: action.payload.RadiologistID,
                }));
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to delete schedule request';
            yield put(actions.deleteScheduleRequestFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to delete schedule request';
        yield put(actions.deleteScheduleRequestFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- Provider PROFILE CHART METRICS --------------------
function* radProfileRadMetricsSaga(action) {
    try {
        const response = yield call(
            services.RadProfileChartDetails,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.RadiologistProfileChartDetailsSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.RadiologistProfileChartDetailsFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch chart metrics';
        yield put(
            actions.RadiologistProfileChartDetailsFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- DOWNLOAD Provider PROFILE IMAGE --------------------
function* downloadRadProfileImageSaga(action) {
    try {
        const response = yield call(
            services.downloadRadProfileImage,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.downloadRadProfileImageSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'Download failed';
            yield put(
                actions.downloadRadProfileImageFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to download profile image';
        yield put(actions.downloadRadProfileImageFailure(errorMessage));
        // SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- DELETE Provider PROFILE IMAGE --------------------
function* deleteRadProfileImageSaga(action) {
    try {
        const response = yield call(
            services.deleteRadProfilePhoto,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.deleteRadProfileImageSuccess(response.values)
            );
            SweetAlert.success({
                title: 'Success!',
                text: 'Profile image deleted successfully.'
            });
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to delete profile image';

            yield put(
                actions.deleteRadProfileImageFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to delete profile image';
        yield put(
            actions.deleteRadProfileImageFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE Provider PROFILE IMAGE --------------------
function* saveRadProfileImageSaga(action) {
    try {
        const response = yield call(
            services.saveRadProfileImage,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.saveRadProfileImageSuccess(response.values)
            );
            SweetAlert.success({
                title: 'Success!',
                text: 'Profile image saved successfully.'
            });
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to save profile image';

            yield put(
                actions.saveRadProfileImageFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to save profile image';

        yield put(
            actions.saveRadProfileImageFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE Provider PROFILE VERIFICATION --------------------
function* saveRadProfileVerificationSaga(action) {
    try {
        const response = yield call(
            services.saveRadProfileVerification,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.saveRadProfileVerificationSuccess(response.values)
            );
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Profile verification updated successfully.'
            });
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to update profile verification';

            yield put(
                actions.saveRadProfileVerificationFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to update profile verification';

        yield put(
            actions.saveRadProfileVerificationFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- PROVIDER METRICS DROPDOWN --------------------
function* fetchRadProviderMetricsDropdownSaga(action) {
    try {
        const response = yield call(
            services.getRadProviderMetricsDropdown,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadProviderMetricsDropdownSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadProviderMetricsDropdownFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Provider Metrics Dropdown';
        yield put(actions.fetchRadProviderMetricsDropdownFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- PROVIDER METRICS CHART DETAILS --------------------
function* fetchRadProviderMetricsChartDetailsSaga(action) {
    try {
        const response = yield call(
            services.getRadProviderMetricsChartDetails,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.fetchRadProviderMetricsChartDetailsSuccess(response.values)
            );
        } else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(
                actions.fetchRadProviderMetricsChartDetailsFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Provider Metrics Chart Details';
        yield put(
            actions.fetchRadProviderMetricsChartDetailsFailure(errorMessage)
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH RAD SITE ASSIGNMENT NOTES --------------------
function* fetchRadSiteAssignmentNotesSaga(action) {
    try {
        const response = yield call(services.getRadSiteAssignmentNotes, action.payload);
        if (response?.success) {
            const notes = response?.value || response?.Value || response?.values || response?.Values || [];
            yield put(actions.fetchRadSiteAssignmentNotesSuccess(Array.isArray(notes) ? notes : []));
        } else {
            yield put(actions.fetchRadSiteAssignmentNotesFailure('No notes found'));
        }
    } catch (error) {
        yield put(actions.fetchRadSiteAssignmentNotesFailure('Failed to fetch notes'));
    }
}

function* fetchRadSiteAssignmentAllNotesSaga(action) {
    try {
        const response = yield call(services.getLicenseAndRadSiteAssignmentNotes, action.payload);
        if (response?.success) {
            const notes = response?.value || response?.Value || response?.values || response?.Values || [];
            yield put(actions.fetchRadSiteAssignmentAllNotesSuccess(Array.isArray(notes) ? notes : []));
        } else {
            yield put(actions.fetchRadSiteAssignmentAllNotesFailure('No notes found'));
        }
    } catch (error) {
        yield put(actions.fetchRadSiteAssignmentAllNotesFailure('Failed to fetch notes'));
    }
}

// -------------------- ADD RAD SITE ASSIGNMENT NOTE --------------------
function* addRadSiteAssignmentNoteSaga(action) {
    try {
        const response = yield call(services.addRadSiteAssignmentNote, action.payload);
        if (response?.success) {
            yield put(actions.addRadSiteAssignmentNoteSuccess());
            yield put(actions.fetchRadSiteAssignmentNotesRequest({
                radiologistSiteAssignmentId: action.payload.RadiologistSiteAssignmentID,
            }));
            SweetAlert.success({ title: 'Success!', text: response?.resultMessage || 'Note added successfully!' });
        } else {
            yield put(actions.addRadSiteAssignmentNoteFailure('Failed to save note'));
            SweetAlert.error({ title: 'Error!', text: response?.errorMessage || 'Failed to save note.' });
        }
    } catch (error) {
        yield put(actions.addRadSiteAssignmentNoteFailure('Failed to save note'));
        SweetAlert.error({ title: 'Error!', text: 'An unexpected error occurred while saving the note.' });
    }
}

// -------------------- RAD TASK FACILITIES --------------------
function* fetchRadTaskFacilitiesSaga(action) {
    const { owner, taskId: requestedTaskId } = action.payload || {};
    try {
        const response = yield call(services.fetchTaskFacilities, requestedTaskId);

        if (response?.success === true) {
            const value = response?.value || response?.values || {};
            const respondedTaskId = value?.TaskId ?? value?.taskId ?? requestedTaskId;
            const facilities = (value?.Facilities || value?.facilities || []).map((item) => ({
                facilityId: item?.FacilityId ?? item?.facilityId,
                facilityName: item?.FacilityName ?? item?.facilityName ?? '',
                isTaskAssociated: Boolean(item?.IsTaskAssociated ?? item?.isTaskAssociated),
                isProviderAssociated: Boolean(item?.IsProviderAssociated ?? item?.isProviderAssociated),
            }));

            yield put(actions.fetchRadTaskFacilitiesSuccess({ owner, taskId: respondedTaskId, facilities }));
            return;
        }

        // Silent failure by design: this is a passive, auto-triggered fetch behind a
        // collapsible section, not a user-initiated action.
        yield put(actions.fetchRadTaskFacilitiesFailure({
            owner,
            taskId: requestedTaskId,
            error: response?.errorMessage || 'Failed to load task facilities.',
        }));
    } catch (error) {
        yield put(actions.fetchRadTaskFacilitiesFailure({
            owner,
            taskId: requestedTaskId,
            error: error?.message || 'Failed to load task facilities.',
        }));
    }
}

// -------------------- ROOT SAGA --------------------
export default function* radSaga() {
    yield takeEvery(types.FETCH_RADPROFILE_REQUEST, fetchRadProfileSaga);
    yield takeEvery(types.ADD_RAD_SCHEDULE_REQUEST, addRadScheduleSaga);
    yield takeEvery(types.SAVE_RAD_SCHEDULE_REQUEST, saveRadScheduleSaga);
    yield takeEvery(types.UPDATE_RAD_SCHEDULE_REQUEST, updateRadScheduleSaga);
    yield takeEvery(
        types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST,
        fetchRadiologistTasksByDateSaga
    );
    yield takeEvery(
        types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST,
        fetchRadProfileAssociatedSiteMatricsSaga
    );
    yield takeEvery(
        types.FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST,
        fetchRadSiteMatrixDropdownSaga
    );
    yield takeEvery(
        types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST,
        fetchSiteMetricsChildTableSaga
    );
    yield takeEvery(
        types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST,
        fetchRadiologistYTDByIDSaga
    );
    yield takeEvery(
        types.FETCH_RAD_DROPDOWN_TASKS_REQUEST,
        fetchRadDropdownTasksSaga
    );
    yield takeEvery(
        types.DELETE_SHIFT_INPUT_DETAILS_REQUEST,
        deleteShiftInputDetailsSaga
    );
    yield takeEvery(
        types.FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST,
        fetchSchedulesByDateRangeSaga
    );
    yield takeEvery(
        types.FETCH_SCHEDULE_REQUEST_REQUEST,
        fetchScheduleRequestSaga
    );
    yield takeEvery(
        types.DELETE_SCHEDULE_REQUEST_REQUEST,
        deleteScheduleRequestSaga
    );
    yield takeEvery(
        types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_REQUEST,
        radProfileRadMetricsSaga
    );
    yield takeEvery(
        types.DOWNLOAD_RAD_PROFILE_IMAGE_REQUEST,
        downloadRadProfileImageSaga
    );
    yield takeEvery(
        types.DELETE_RAD_PROFILE_IMAGE_REQUEST,
        deleteRadProfileImageSaga
    );
    yield takeEvery(
        types.SAVE_RAD_PROFILE_IMAGE_REQUEST,
        saveRadProfileImageSaga
    );
    yield takeEvery(
        types.SAVE_RAD_PROFILE_VERIFICATION_REQUEST,
        saveRadProfileVerificationSaga
    );
    yield takeEvery(
        types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_REQUEST,
        fetchRadProviderMetricsDropdownSaga
    );
    yield takeEvery(
        types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_REQUEST,
        fetchRadProviderMetricsChartDetailsSaga
    );
    yield takeEvery(types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_REQUEST, fetchRadSiteAssignmentNotesSaga);
    yield takeEvery(types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_REQUEST, fetchRadSiteAssignmentAllNotesSaga);
    yield takeEvery(types.ADD_RAD_SITE_ASSIGNMENT_NOTE_REQUEST, addRadSiteAssignmentNoteSaga);
    // takeEvery (not takeLatest): the taskColumnModal/updateSchedule/providerSchedule owners can
    // have legitimately-concurrent in-flight requests; stale-response protection lives in the
    // reducer instead (per-owner taskId match check).
    yield takeEvery(types.FETCH_RAD_TASK_FACILITIES_REQUEST, fetchRadTaskFacilitiesSaga);
}
